import { useState } from 'react'
import { useAuthContext } from './useAuthContext'

const API_URL = process.env.REACT_APP_API_URL;

export const useSignup = () => {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  const { dispatch } = useAuthContext()

  const signup = async (email, password, name) => {
    setIsLoading(true)
    setError(null)

    const response = await fetch(`${API_URL}/api/users/signup`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ email, password, name })
    })
    const json = await response.json()

    if (!response.ok) {
      setIsLoading(false)
      setError("account creation failed")
      return false
    }
    if (response.ok) {
      // save the user to local storage
      localStorage.setItem('user', JSON.stringify(json))

      // update the auth context
      dispatch({type: 'LOGIN', payload: json})

      // update loading state
      setIsLoading(false)
      return true
    }
  }

  return { signup, isLoading, error }
}